// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".comment-textarea{position:relative}.comment-textarea a{color:#386ff2}.comment-textarea .share-nick{color:#333;font-weight:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
